import {
  currencyOptions,
  diaAccessTechOptions,
  biaIpTypeOptions,
} from "@/common/const";
import {
  diaInterfaceTechOptions,
  includedOptions,
} from "@/common/const/filter-options";
import quoteCreationTypeOptions from "@/common/const/quote/quoteCreationTypes.const";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const diaQuoteLineStrategy: FormFieldsStrategyType[] = [
  {
    label: "Currency",
    name: "currency",
    required: true,
    readonly: true,
    inputType: "select",
    options: currencyOptions,
  },
  {
    inputType: "text",
    label: "OTE",
    name: "OTE",
    required: true,
  },
  {
    inputType: "text",
    label: "MRE",
    name: "MRE",
    required: true,
  },
  {
    inputType: "select",
    label: "Quote Type",
    required: false,
    readonly: false,
    name: "quoteType",
    options: quoteCreationTypeOptions,
  },
  {
    inputType: "text",
    label: "Last Mile Provider",
    name: "lastMileProvider",
    required: true,
  },

  {
    inputType: "text",
    label: "Bandwidth (in Mbps)",
    name: "bandWidth",
    required: true,
    patternMessage: "Value not satisfied range from 0.128 to 10,000",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
  },

  {
    inputType: "select",
    label: "Local Tax/VAT*",
    name: "isLocalTax",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "Local Tax/VAT (in %)",
    name: "localTax",
    required: true,
  },
  {
    inputType: "select",
    label: "Access Technology",
    name: "AccessTechnology",
    required: true,
    options: diaAccessTechOptions,
  },
  {
    inputType: "select",
    label: "Interface/Handoff Type",
    name: "interface",
    required: true,
    options: diaInterfaceTechOptions,
  },
  {
    inputType: "select",
    label: "IP",
    name: "IP",
    required: true,
    options: biaIpTypeOptions,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: true,
  },
  {
    inputType: "text",
    label: "SLA Uptime (in %)",
    name: "SlaUptime",
    required: true,
  },
  {
    inputType: "text",
    label: "SLA MTTR (in Hours)",
    name: "SlaMTTR",
    required: true,
  },
  {
    inputType: "select",
    label: "Network Status",
    name: "networkStatus",
    required: false,
    readonly: false,
    options: [
      {
        label: "Off Net",
        value: "OfNet",
      },
      {
        label: "Near Net",
        value: "NearNet",
      },
      {
        label: "On Net",
        value: "OnNet",
      },
    ],
  },
  {
    inputType: "select",
    label: "The source of the price",
    name: "source",
    required: false,
    readonly: true,
    options: [
      {
        label: "Manual",
        value: "manual",
      },
      {
        label: "Building List",
        value: "BuildingList",
      },
      {
        label: "Country Coverage",
        value: "CountryCoverage",
      },
    ],
  },
  {
    inputType: "textarea",
    label: "Note",
    name: "description",
    required: false,
  },
];

export default diaQuoteLineStrategy;
// source;
